// Map Components and Run time partners

import React from "react"
import { navigate } from "gatsby"
import { useAppContext } from "../../context/appContext"
import { onContactUsBtnClick } from "../../commonFunctions/commonFunctions"
import TechoMap from "./../../images/TechoMap.png"
import AWS from "./../../images/runtime-partners-assets/AWS.png"
import GCP from "./../../images/runtime-partners-assets/GCP.png"
import Azure from "./../../images/runtime-partners-assets/Azure.png"

import "./MapComponent.scss"

const MapComponent = ({ data }) => {
  const { setShowContactFormWindow } = useAppContext()

  const statisticCardsData = [
    { label: "Hours of Product Development Delivered", value: "2 Million +" },
    { label: "AI Powered Engineers", value: "5000 +" },
    { value: "500 +", label: "Human Capital" },
    { value: "300 +", label: "Clients Worldwide" },
    { value: "50 +", label: "Fortune 500 Clients" },
    { value: "9 +", label: "Years in Business" },
  ]

  return (
    <div
      className="section homepage homepage-map-component-section"
      id="Building-better-future-section"
    >
      {/* Map Component */}
      <h2 className="homepage-section-title">
        {data?.slide_title != null
          ? data?.slide_title
          : "Building a Better Future with AI"}
      </h2>
      <div className="map-component-content">
        <div className="map-poster">
          <img src={TechoMap} alt="Techolution locations" loading="lazy" />
        </div>
        <div className="statistic-cards-container">
          {data?.techolutionStats?.length > 0
            ? data?.techolutionStats?.map((values, key) => (
                <div key={key} className="statistic-card">
                  <span className="statistic-value">{values?.title}</span>
                  <span className="statistic-label">{values?.description}</span>
                </div>
              ))
            : statisticCardsData?.map((values, key) => (
                <div key={key} className="statistic-card">
                  <span className="statistic-value">{values?.value}</span>
                  <span className="statistic-label">{values?.label}</span>
                </div>
              ))}
        </div>
      </div>

      {/* Runtime Partners */}
      <div className="partners-container">
        <p className="section-header">
          "To go fast, go alone." To go far with AI, <br />
          let’s go together with our strategic cloud runtime partners.
        </p>
        <div className="partners-buttons-container">
          <div className="button_container">
            <button
              type="button"
              className="button-cl connectBtn cloudButton"
              onClick={() => navigate("/google-cloud")}
            >
              <img
                src={GCP}
                loading="lazy"
                alt="google cloud icon"
                className="google-cloud-icon cloudIcon"
              />
              Google Cloud
            </button>
          </div>

          <div className="button_container">
            <button
              type="button"
              className="button-cl connectBtn cloudButton"
              onClick={() => navigate("/microsoft-azure")}
            >
              <img
                src={Azure}
                loading="lazy"
                alt="azure icon"
                className="google-cloud-icon cloudIcon"
              />
              Microsoft Azure
            </button>
          </div>

          <div className="button_container">
            <button
              type="button"
              disabled
              className=" btn-disabled button-cl connectBtn cloudButton"
              onClick={() =>
                onContactUsBtnClick(
                  "Edge_Compute_cta",
                  setShowContactFormWindow
                )
              }
              style={{ pointerEvents: "none" }}
            >
              <img
                src={AWS}
                loading="lazy"
                alt="aws icon"
                className="google-cloud-icon cloudIcon"
              />
              Amazon Web Services
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MapComponent
